import AgeOfTanksWarriorsTdWar from './age-of-tanks-warriors-td-war.webp'
import AgeOfTanksWarriorsTdWarFod from './age-of-tanks-warriors-td-war_fod.webp'
import BubbleBlast from './bubble-blast.webp'
import BubbleBlastFod from './bubble-blast_fod.webp'
import ChessOnlineMultiplayer from './chess-online-multiplayer.webp'
import ChessOnlineMultiplayerFod from './chess-online-multiplayer_fod.webp'
import DeadlyDescent from './deadly-descent.webp'
import DeadlyDescentFod from './deadly-descent_fod.webp'
import FruitMergePlaygama from './fruit-merge-playgama.webp'
import FruitMergePlaygamaFod from './fruit-merge-playgama_fod.webp'
import GangsterIslandCrimeCity from './gangster-island-crime-city.webp'
import GangsterIslandCrimeCityFod from './gangster-island-crime-city_fod.webp'
import GoodSortMaster from './good-sort-master.webp'
import GoodSortMasterFod from './good-sort-master_fod.webp'
import HeroDefenseKing from './hero-defense-king.webp'
import HeroDefenseKingFod from './hero-defense-king_fod.webp'
import HiddenObjectMyHotel from './hidden-object-my-hotel.webp'
import HiddenObjectMyHotelFod from './hidden-object-my-hotel_fod.webp'
import MillionaireLife from './millionaire-life.webp'
import MillionaireLifeFod from './millionaire-life_fod.webp'
import MrRacerCarRacing from './mr-racer-car-racing.webp'
import MrRacerCarRacingFod from './mr-racer-car-racing_fod.webp'
import MyTownHomeFamilyPlayhouse from './my-town-home-family-playhouse.webp'
import MyTownHomeFamilyPlayhouseFod from './my-town-home-family-playhouse_fod.webp'
import PieceOfCakeMergeBake from './piece-of-cake-merge--bake.webp'
import PieceOfCakeMergeBakeFod from './piece-of-cake-merge--bake_fod.webp'
import Snake2048 from './snake-2048-64be-1.webp'
import Snake2048Fod from './snake-2048-64be-1_fod.webp'
import SpeedPerClickObby from './speed-per-click-obby.webp'
import SpeedPerClickObbyFod from './speed-per-click-obby_fod.webp'
import TbWorld from './tb-world.webp'
import TbWorldFod from './tb-world_fod.webp'
import VegaMix2Adventure from './vega-mix-2-adventure.webp'
import VegaMix2AdventureFod from './vega-mix-2-adventure_fod.webp'

// copied from https://github.com/HatScripts/circle-flags
// TODO fix blurry on Safari — replace Mask with border-radius

export const topPlaygamaIcons: Record<string, string> = {
    'age-of-tanks-warriors-td-war': AgeOfTanksWarriorsTdWar,
    'age-of-tanks-warriors-td-war_fod': AgeOfTanksWarriorsTdWarFod,
    'bubble-blast': BubbleBlast,
    'bubble-blast_fod': BubbleBlastFod,
    'chess-online-multiplayer': ChessOnlineMultiplayer,
    'chess-online-multiplayer_fod': ChessOnlineMultiplayerFod,
    'deadly-descent': DeadlyDescent,
    'deadly-descent_fod': DeadlyDescentFod,
    'fruit-merge-playgama': FruitMergePlaygama,
    'fruit-merge-playgama_fod': FruitMergePlaygamaFod,
    'gangster-island-crime-city': GangsterIslandCrimeCity,
    'gangster-island-crime-city_fod': GangsterIslandCrimeCityFod,
    'good-sort-master': GoodSortMaster,
    'good-sort-master_fod': GoodSortMasterFod,
    'hero-defense-king': HeroDefenseKing,
    'hero-defense-king_fod': HeroDefenseKingFod,
    'hidden-object-my-hotel': HiddenObjectMyHotel,
    'hidden-object-my-hotel_fod': HiddenObjectMyHotelFod,
    'millionaire-life': MillionaireLife,
    'millionaire-life_fod': MillionaireLifeFod,
    'mr-racer-car-racing': MrRacerCarRacing,
    'mr-racer-car-racing_fod': MrRacerCarRacingFod,
    'my-town-home-family-playhouse': MyTownHomeFamilyPlayhouse,
    'my-town-home-family-playhouse_fod': MyTownHomeFamilyPlayhouseFod,
    'piece-of-cake-merge--bake': PieceOfCakeMergeBake,
    'piece-of-cake-merge--bake_fod': PieceOfCakeMergeBakeFod,
    'snake-2048-64be-1': Snake2048,
    'snake-2048-64be-1_fod': Snake2048Fod,
    'speed-per-click-obby': SpeedPerClickObby,
    'speed-per-click-obby_fod': SpeedPerClickObbyFod,
    'tb-world': TbWorld,
    'tb-world_fod': TbWorldFod,
    'vega-mix-2-adventure': VegaMix2Adventure,
    'vega-mix-2-adventure_fod': VegaMix2AdventureFod,
}
